import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/Services/auth.service';
import { DashboardService } from 'src/app/Services/dashboard.service';
import { AdminDashboardApiResponce } from 'src/app/models/response/artistoverlaydashboard.model';

@Component({
    selector: 'ds-admin-dashboard',
    templateUrl: './ds-admin-dashboard.component.html',
    styleUrls: ['./ds-admin-dashboard.component.css'],
    providers: [DashboardService],
    standalone: false
})
export class DsAdminDashboardComponent implements OnInit {
    public adminDashboardData!: AdminDashboardApiResponce;
    public dashboardDataLoaded: boolean = false;
    public firstName: string = '';
    public isSuperAdmin: boolean = false;
    public selectedTabIndex: number = 0;

    constructor(
        private ngxSpinner: NgxSpinnerService,
        private router: Router,
        private authService: AuthService,
        private dashboardService: DashboardService
    ) { }

    public ngOnInit(): void {
        const currentUser = this.authService.getCurrentUser();
        this.firstName = currentUser?.FirstName || 'Admin';
        this.isSuperAdmin = this.authService.IsSuperAdmin();
        this.getAdminDashboard();
    }

    public getAdminDashboard() {
        this.ngxSpinner.show();
        this.dashboardService.getAllSubscriptions().subscribe(
            (res: AdminDashboardApiResponce) => {
                this.adminDashboardData = res;
                this.ngxSpinner.hide();
                this.dashboardDataLoaded = true;
            },
            (error) => {
                console.error('Error fetching admin dashboard data', error);
                this.ngxSpinner.hide();
            }
        );
    }

    public onTabChange(event: any) {
        if (event.index !== undefined) {
            this.selectedTabIndex = event.index;
        }
    }

    // Quick Action navigation
    public navigateToArtists() {
        this.router.navigate(['/admin', 'view']);
    }

    public navigateToGalleries() {
        this.router.navigate(['/admin', 'view-galleries']);
    }

    public navigateToEmailTemplates() {
        this.router.navigate(['/admin', 'email-templates']);
    }

    public navigateToSubscriptionRules() {
        this.router.navigate(['/subscription-rules']);
    }

    public navigateToSystemSettings() {
        this.router.navigate(['/system-settings']);
    }

    // Quick Links navigation
    public navigateToApplicationLogs() {
        this.router.navigate(['/admin', 'application-log']);
    }

    public navigateToEmailLogs() {
        this.router.navigate(['/admin', 'email-track-log']);
    }

    public navigateToArtTypes() {
        this.router.navigate(['/admin', 'art-type']);
    }

    public navigateToEventWorkflow() {
        this.router.navigate(['/admin', 'system-events-workflow']);
    }

    public navigateToSmsTemplates() {
        this.router.navigate(['/admin', 'sms-templates']);
    }

    public navigateToAdmins() {
        this.router.navigate(['/admins']);
    }

    public navigateToEmailEvents() {
        this.router.navigate(['/admin', 'email-events']);
    }

    get totalUsers(): number {
        if (!this.adminDashboardData) return 0;
        return (this.adminDashboardData.ArtistAccounts?.TotalArtist || 0) +
               (this.adminDashboardData.GalleryAccounts?.TotalGallery || 0);
    }

    get artistProPercentage(): number {
        if (!this.adminDashboardData?.ArtistAccounts?.TotalArtist) return 0;
        return Math.round(((this.adminDashboardData.ArtistAccounts.TotalProArtist || 0) / this.adminDashboardData.ArtistAccounts.TotalArtist) * 100);
    }

    get galleryProPercentage(): number {
        if (!this.adminDashboardData?.GalleryAccounts?.TotalGallery) return 0;
        return Math.round(((this.adminDashboardData.GalleryAccounts.TotalProGallery || 0) / this.adminDashboardData.GalleryAccounts.TotalGallery) * 100);
    }
}
